import { Panel, Modal } from '@studiometa/ui';
import Buybox from './Product/Buybox.js';

/**
 * QuickBuyPanel component
 */
export default class QuickBuyPanel extends Panel {
  /**
   * Component Configuration
   */
  static config = {
    name: 'QuickBuyPanel',
    components: {
      Buybox,
    },
    refs: [...Modal.config.refs, 'content'],
  };

  /**
   *
   */
  mounted() {
    document.addEventListener('liquid-ajax-cart:request-end', (event) => {
      const { requestState } = event.detail;

      // If the "add to cart" request is successful
      if (requestState.requestType === 'add' && requestState.responseData?.ok) {
        this.close();
      }
    });
  }

  /**
   * Called by another component (QuickBuy)
   * @param {object} props
   * @param {Event} props.event
   */
  onDocumentOpenPanel({ event }) {
    const html = event.detail[0];
    this.$refs.content.innerHTML = html;
    super.open();
  }
}
